import { axios } from '@/utils/request'

const api = {
  getGoodsDetail: '/adminapi/vote/getGoodsDetail',
  voteGoodsList: '/adminapi/vote/voteGoodsList',
  GoodsEdit: '/adminapi/vote/voteGoodsEdit',
  GoodsAdd: '/adminapi/vote/voteGoodsAdd',
  setGoodsRank: '/adminapi/vote/setGoodsRank',
  deleteGoods: '/adminapi/vote/deleteGoods',
}

export default api

export function getvoteGoodsList(parameter) {
  return axios({
    url: api.voteGoodsList,
    method: 'get',
    params: parameter
  })
}
export function getGoodsDetail(parameter) {
  return axios({
    url: api.getGoodsDetail,
    method: 'get',
    params: parameter
  })
}

export function editGoods(parameter) {
  return axios({
    url: api.GoodsEdit,
    method: 'post',
    data: parameter
  })
}
export function addGoods(parameter) {
  return axios({
    url: api.GoodsAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteGoods(parameter) {
  return axios({
    url: api.deleteGoods,
    method: 'post',
    data: parameter
  })
}

export function setGoodsRank(parameter) {
  return axios({
    url: api.setGoodsRank,
    method: 'post',
    data: parameter
  })
}
